import { lazy } from 'react';

export const SubmitReviewStatusForm = lazy(
  () => import('./SubmitReviewStatusForm'),
);
